


































import { Vue, Component, Prop } from "vue-property-decorator";
import meta from "@/general/store/modules/meta";
import sitemap from "@/general/mixins/const/custom/sitemap";

@Component
export default class Error404 extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) error!: boolean;
  toppage = sitemap.TOP_PAGE;
  mounted() {
    meta.setDocumentTitle("お探しのページが見つかりません。");
    // this.$meta.setDocumentTitle("お探しのページが見つかりません。");
    // this.$page.isBreadcrumb = false;
    // this.$page.isPageHeader = false;
  }

  // watch: {
  //   $route() {
  //     this.$meta.setDocumentTitle("お探しのページが見つかりません。");
  //     this.$page.isBreadcrumb = false;
  //     this.$page.isPageHeader = false;
  //   }
  // }
}
